(function () {
  if (window.__sipitCollectionInit) return;
  window.__sipitCollectionInit = true;

  const roots = document.querySelectorAll('.sipit-collection');
  if (!roots.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  roots.forEach((root) => {
    root.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });
  });
})();
